<div class="workSpace">
   <!-- Titulo -->
  <div class="w3-container w3-container-template headersTab">
    <!--Titulo de modulo y subtitulo-->
    <div class="w3-caja-menu padreizquierda">
      <div class="w3-row hijoizquierda centradoVertical w3-third">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ 'menu.'+dataService.moduleSelect | translate }} </b></span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ 'menu.'+dataService.subModuleSelect | translate }} </span>
      </div>
      <div class="w3-row w3-rest w3-center centradoVertical institucion" (click)="selectInst()">
        <span>{{instSelecc.alias || ''}}</span>
      </div>
    </div>
  </div>
  <!-- TABLERO -->
  <div class="w3-row workSpaceTab">
    <div class="w3-row w3-right">
      <button class="download btn" (click)="descargarArchivo()">
        <mat-icon class="icon">download</mat-icon>
        {{'proyFinanciera.cargaInformacion.catalogo' | translate}}
      </button>
    </div>
    <div class="w3-row" style="width: 100%;">
      <div class="w3-row" style="height: 78vh;">
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" color="warn" style="height: 80vh;" (selectedTabChange)="cambiarTab($event)">
          <!-- CONSOLIDADO -->
          <mat-tab label="{{'proyFinanciera.cargaInformacion.consolidado' | translate}}">
            <div class="w3-row w3-white" style="height: 69vh; padding: 5px">
              <div class="w3-row w3-margin-left-filter w3-titulo-contenidomenu">{{'proyFinanciera.cargaInformacion.tituloTabla' | translate}}</div>
              <div class="w3-row w3-scroll">
                <table class="w3-table">
                  <thead>
                    <tr class="w3-table-titleLow w3-center">
                      <th class="w3-border-right-balance marginsH stikyColum sticky-col"> {{'proyFinanciera.cargaInformacion.anio' | translate}} </th>
                      @for (item of encabezados; track $index) {
                        <th class="w3-border-right-balance marginsH stikyColum"> {{item}} </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (per of listPeriodos; track $index) {
                      <tr class="w3-table-trtd">
                        <td class="borderAllLow marginsH sticky-col w3-white" style="min-width: 80px;">{{per.anio}}</td>
                        @for (mes of per.meses; track $index) {
                          <td class="borderAllLow marginsH w3-center" style="min-width: 120px !important;">
                            <button class="btn w3-center" [ngClass]="mes.activo ? 'periodoActivo' : 'periodoInactivo'" (click)="accionesPeriodo(per.anio, mes)"
                              matTooltip="{{mes.activo ? 'Descargar información' : 'Subir información'}}">
                              <span>{{mes.activo ? 'Descargar' : 'Subir'}}</span>
                            </button>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </mat-tab>
          <!-- SUCURSALES -->
          <mat-tab label="{{'proyFinanciera.cargaInformacion.sucursales' | translate}}">
            <div class="w3-row w3-white" style="height: 49%; padding: 5px">
              <div class="w3-row">
                <div class="w3-row w3-half w3-margin-left-filter w3-titulo-contenidomenu" style="width: fit-content;margin-right: 8px;">{{'proyFinanciera.cargaInformacion.tituloTabla' | translate}} | Sucursal </div>
                  <div class="w3-rest alinLeft" style="font-weight: 500; margin-top: 6px; width: 20vw;">
                    <mat-select [(value)]="sucursalSelect" (selectionChange)="cambiarSucursal($event)" placeholder="{{'proyFinanciera.configCatalogo.selecInst' | translate}}">
                      @for (suc of dataSucursales; track $index) {
                        @if(!suc.consolidado){<mat-option [value]="suc">{{suc.nombre}}</mat-option>}                          
                      }
                    </mat-select>
                  </div>
              </div>              
              <div class="w3-row">
                <table class="w3-table">
                  <thead>
                    <tr class="w3-table-titleLow w3-center">
                      <th class="w3-border-right-balance marginsH stikyColum sticky-col"> {{'proyFinanciera.cargaInformacion.anio' | translate}} </th>
                      @for (item of encabezados; track $index) {
                        <th class="w3-border-right-balance marginsH stikyColum"> {{item}} </th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @if (sucursalSelect) {
                      @for (per of listPeriodos; track $index) {
                        <tr class="w3-table-trtd">
                          <td class="borderAllLow marginsH sticky-col w3-white" style="min-width: 80px;">{{per.anio}}</td>
                          @for (mes of per.meses; track $index) {
                            <td class="borderAllLow marginsH w3-center" style="min-width: 120px !important;">
                              <button class="btn w3-center" [ngClass]="mes.activo ? 'periodoActivo' : 'periodoInactivo'" (click)="accionesPeriodo(per.anio, mes)"
                                matTooltip="{{mes.activo ? 'Descargar información' : 'Subir información'}}">
                                <span>{{mes.activo ? 'Descargar' : 'Subir'}}</span>
                              </button>
                            </td>
                          }
                        </tr>
                      }
                    }                    
                  </tbody>
                </table>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>        
      </div>
    </div>
  </div>
</div>